import { fsDateUtils } from './fsDateUtils';

/**
 * Filter to format a date according to the settings
 */
/** @ngInject */
export function fsDateNoLocalFilter($cookies, userService) {
    return htmlCode => fsDateUtils.toString(htmlCode, userService, $cookies,
            format => format.substring(0, format.indexOf(' ')),false); // keep only date format, scrap time
}
